export default "__VITE_ASSET__f36dcb35__"